import { createClient } from '@supabase/supabase-js';
import { useEffect, useState } from 'react';
import Select from 'react-select';
// import { VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY } from 'react-native-dotenv';

const supabaseUrl = 'https://lfgomkfmhxqiltpsylwp.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxmZ29ta2ZtaHhxaWx0cHN5bHdwIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY3NjM1NzU5NiwiZXhwIjoxOTkxOTMzNTk2fQ.dTAmvaPfheDTxUJ65ZXc_Me5cGUfzRDxa2v8wjb9Wng';
const supabase = createClient(supabaseUrl, supabaseKey);

const options = [
  { value: null, label: 'All' },
  { value: 'arts-culture', label: 'Arts / Culture'},
  { value: 'comedy', label: 'Comedy'},
  { value: 'digital-events', label: 'Digital Events'},
  { value: 'dj-parties', label: 'DJ Parties'},
  { value: 'food-drink', label: 'Food / Drink'},
  { value: 'karaoke-trivia-open-mics', label: 'Karaoke / Trivia / Open-mics'},
  { value: 'music', label: 'Music'},
  { value: 'sports-fitness', label: 'Sports / Fitness'},
  { value: 'theatre-performing-arts', label: 'Theatre / Performing Arts'},
  { value: 'tv-film', label: 'TV / Film'}
];

const options_converter = Object.assign({}, ...options.map((x) => ({[x.value]: x.label})));

function SupabaseTable() {
  const [data, setData] = useState([]);
  const [category, setCategory] = useState("");

  const roulette = () => {
    const rouletteButton = document.querySelector(".roulette")
    if (rouletteButton.textContent=="Roulette") {
      fetchData(category, true);
      rouletteButton.textContent = "RESET"
      rouletteButton.style.background = 'Red';
    }
    else
    {
      fetchData(category, false);
      rouletteButton.textContent = "Roulette"
      rouletteButton.style.background = 'rgb(' + [141,217,252].join(',') + ')';
    }
  }

  const handleChange = (selectedOption) => {
    setCategory(selectedOption.value);
    fetchData(selectedOption.value, false);
    const rouletteButton = document.querySelector(".roulette")
    rouletteButton.textContent = "Roulette"
    rouletteButton.style.background = 'rgb(' + [141,217,252].join(',') + ')';
  };

  // Back to top button
  const showOnPx = 500;
  const backToTopButton = document.querySelector(".back-to-top")

  const scrollContainer = () => {
    return document.documentElement || document.body;
  };

  document.addEventListener("scroll", () => {
    if (scrollContainer().scrollTop > showOnPx) {
      backToTopButton.classList.remove("hidden")
    } else {
      backToTopButton.classList.add("hidden")
    }
  });

  const goToTop = () => {
    document.body.scrollIntoView();
  };

  // Load data
  useEffect(() => {
    fetchData(category)
  }, [])

  async function fetchData(category, rouletteActive) {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;
    
    if (!category) {
      var { data: tableData } = await supabase.from('page_table').select('*').gte('local_date', today).order('local_date', 'start_time').limit(400);
      if (rouletteActive) {
        tableData = [tableData[Math.floor(Math.random()*tableData.length)]];
      }
      const groups = tableData.reduce((groups, event) => {
        const date = event.local_date;
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(event);
        return groups;
      }, {});
      
      const groupArrays = Object.keys(groups).map((date) => {
        return {
          date,
          events: groups[date]
        };
      });
      setData(groupArrays);
    }
    else
    {
      var { data: tableData } = await supabase.from('page_table').select('*').gte('local_date', today).eq('category', category).order('local_date', 'start_time').limit(400);
      if (rouletteActive) {
        tableData = [tableData[Math.floor(Math.random()*tableData.length)]];
      }
      const groups = tableData.reduce((groups, event) => {
        const date = event.local_date;
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(event);
        return groups;
      }, {});
      
      const groupArrays = Object.keys(groups).map((date) => {
        return {
          date,
          events: groups[date]
        };
      });
      setData(groupArrays);
    }
  };
  
  const styles = {
    container: base => ({
      ...base,
      flex: 1
    })
  };

  return (
    <table width="80%" align="center">
      <div class="menu-items" >
        <Select id="categorySelector" styles={styles} placeholder='Category...' isSearchable={false} options={options} onChange={handleChange} autoFocus={true} />
        <button onClick={roulette} class="roulette">Roulette</button>
      </div>
      {data.map((date) => (
        <div>
        <div class="sticky" key={date.date}><hr/><b>{new Date(date.date).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric", timeZone: "UTC"})}</b><hr/></div>
        {date.events.map((row) => (
          <div class="display-table-row" key={row.id}> <a href={`https://do303.com/${row.url}`} target="_blank">{row.title}</a>
            <div>{row.location} ({row.area}) @ <b>{row.local_time}</b></div>
            <b><div>{options_converter[row.category]}</div></b>
          </div>
        ))}
        <hr/>
        </div>
      ))}
      <button onClick={goToTop} class="back-to-top hidden">Back To Top</button>
    </table>
  );
}

export default SupabaseTable;
